import DealBody from './DealBody';

export default DealBody;
